export default __webpack_public_path__ + "static/media/acca_logo_txt@3x.3c967c07.png";